<div class="row">
  <div class="col-12">
    <span class="m-name">{{ "MANUFACTURER" | translate }} #{{ sequence }}:</span>
    <span>{{ invoiceEntity?.manufacturer?.name || (invoiceEntity?.manufacturer?.entityIdentifier | identifier) }}</span>
  </div>
</div>
<ng-container *ngIf="invoiceEntity.lines.length">
  <div class="row" *ngFor="let lineItem of invoiceEntity.lines">
    <div class="col-6 card-label">{{ lineItem.htsNumber | mask : HTS_MASK }}</div>
    <div class="col-6">{{ lineItem.countryOfOrigin.code }} {{ lineItem.countryOfOrigin.description }}</div>

    <div *ngIf="showHtsDescription && description(lineItem.htsNumber)" class="col-6 card-label">
      {{ "LABELS.DESCRIPTION" | translate }}
    </div>
    <div *ngIf="showHtsDescription && description(lineItem.htsNumber)" class="col-6">{{ description(lineItem.htsNumber) }}</div>
  </div>
</ng-container>
<ng-container *ngIf="!invoiceEntity.lines.length">
  <div class="row">
    <div class="col-12 text-error">{{ "MISSING_HTS_IN_M" | translate }}</div>
  </div>
</ng-container>
